import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type AssetsReportsSidebarType from './ui/index.tsx';

export const LazyAssetsReportsSidebar = lazyForPaint<typeof AssetsReportsSidebarType>(() => {
	setPerformanceMarkLoadStart();
	return import(/* webpackChunkName: "async-sidebar-assets-reports" */ './index').then((bundle) => {
		setPerformanceMarkLoadEnd();
		return bundle;
	});
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AssetsReportsSidebar = memo<Record<any, any>>(() => (
	<SidebarBoundary id="assets-reports-sidebar">
		<LazyAssetsReportsSidebar />
	</SidebarBoundary>
));

AssetsReportsSidebar.displayName = 'AssetsReportsSidebar';

export default AssetsReportsSidebar;
